import { render } from "./resetUserPasswordPopup.vue?vue&type=template&id=c1f215e6&scoped=true"
import script from "./resetUserPasswordPopup.vue?vue&type=script&lang=js"
export * from "./resetUserPasswordPopup.vue?vue&type=script&lang=js"

import "./resetUserPasswordPopup.vue?vue&type=style&index=0&id=c1f215e6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1f215e6"]])

export default __exports__